import { DialogContent } from '@mui/material'
import Divider from '@mui/material/Divider'
import MenuItem from '@mui/material/MenuItem'
import { styled } from '@mui/system'
import T from 'prop-types'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import FormTextField from 'components/atoms/FormTextField'

const createStatuses = (t) => [
  { label: t('users.status.disabled'), value: 'disabled' },
  { label: t('users.status.enabled'), value: 'enabled' },
]

const PartnerInfoFields = ({ partnersGroups }) => {
  const { t } = useTranslation()

  const statuses = useMemo(() => createStatuses(t), [t])

  return (
    <>
      <DialogContent>
        <FormTextField
          name="partnerId"
          label={t('users.tableColumns.partnerId')}
          fullWidth
        />
        <FormTextField
          name="partnerIdB2b"
          label={t('users.tableColumns.partnerIdB2b')}
          fullWidth
        />
        <FormTextField
          name="name"
          label={t('users.tableColumns.partnerName')}
          fullWidth
        />
        <FormTextField
          name="vat"
          label={t('users.tableColumns.vat')}
          fullWidth
        />
        <FormTextField
          name="notes"
          label={t('users.tableColumns.notes')}
          fullWidth
        />

        <FormTextField
          select
          name="partnerGroup"
          label={t('users.tableColumns.partnerGroup')}
          fullWidth
        >
          {partnersGroups.map((option) => (
            <MenuItem key={option.partnerGroupId} value={option.partnerGroupId}>
              {option.name}
            </MenuItem>
          ))}
        </FormTextField>
      </DialogContent>

      <Divider />

      <DialogContent>
        <Row>
          <FormTextField
            select
            name="status"
            label={t('users.tableColumns.status')}
            fullWidth
          >
            {statuses.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </FormTextField>
        </Row>
      </DialogContent>

      <Divider />
    </>
  )
}

PartnerInfoFields.propTypes = {
  allowedRoles: T.any,
  partnersGroups: T.array,
}

export default PartnerInfoFields

const Row = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  '& > div:first-of-type': {
    marginRight: theme.spacing(2),
  },
  '& > div:nth-of-type(3)': {
    marginLeft: theme.spacing(2),
  },
}))
